import React, { useState } from 'react'
import _, { isEmpty } from 'lodash'
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  InputNumber
} from 'antd'

import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'

const PlansForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [watermarkValue, setWatermarkValue] = useState(null)
  const [sentEmailReportValue, setSentEmailReportValue] = useState(null)
  const [alertSettingValue, setAlertSettingValue] = useState(null)
  const [limitWeighingValue, setLimitWeighingValue] = useState(null)
  const [limitAccountingValue, setLimitAccountingValue] = useState(null)

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        detail: formData.detail,
        price: formData.price,
        time: formData.time,
        limitWeighing: formData.limitWeighing,
        limitAccounting: formData.limitAccounting,
        saveImageLongTime: formData.saveImageLongTime,
        remark: formData.remark
      })

      if (formData.watermark !== undefined && formData.watermark !== null) {
        setWatermarkValue(formData.watermark ? 'show' : 'hide')
      } else {
        setWatermarkValue(null)
      }
      if (
        formData.sentEmailReport !== undefined &&
        formData.sentEmailReport !== null
      ) {
        setSentEmailReportValue(formData.sentEmailReport ? 'show' : 'hide')
      } else {
        setSentEmailReportValue(null)
      }
      if (
        formData.alertSetting !== undefined &&
        formData.alertSetting !== null
      ) {
        setAlertSettingValue(formData.alertSetting ? 'show' : 'hide')
      } else {
        setAlertSettingValue(null)
      }
      formData.limitWeighing === 0
        ? setLimitWeighingValue('limitWeighingZero')
        : setLimitWeighingValue(null)
      formData.limitAccounting === 0
        ? setLimitAccountingValue('limitAccountingZero')
        : setLimitAccountingValue(null)
    } else {
      setWatermarkValue(null)
      setSentEmailReportValue(null)
      setAlertSettingValue(null)
      setLimitWeighingValue(null)
      setLimitAccountingValue(null)
    }

    return () => {
      form.resetFields()
    }
  }, [formData])

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          detail: values.detail ? values.detail : null,
          price: values.price,
          time: values.time,
          limitWeighing: values.limitWeighing ? values.limitWeighing : 0,
          limitAccounting: values.limitAccounting ? values.limitAccounting : 0,
          watermark: watermarkValue === 'show',
          saveImageLongTime: values.saveImageLongTime
            ? values.saveImageLongTime
            : null,
          sentEmailReport: sentEmailReportValue === 'show',
          alertSetting: alertSettingValue === 'show',
          remark: values.remark ? values.remark : null,
          isShow: true
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }

  return (
    <Modal
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Plan`}
      visible={visible}
      footer={null}
      onCancel={onCancel}
      width={600}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
        <Form.Item label="Plan Name">
          {getFieldDecorator(`name`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(<Input name="name" placeholder="ชื่อ Plan" />)}
        </Form.Item>
        <Form.Item label="Plan Detail">
          {getFieldDecorator(`detail`)(
            <Input.TextArea name="name" placeholder="รายละเอียด" />
          )}
        </Form.Item>
        <Form.Item label="Plan Price">
          {getFieldDecorator(`price`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <InputNumber
              name="name"
              placeholder="ราคา"
              style={{ width: '100%' }}
              min={0}
            />
          )}
        </Form.Item>
        <Form.Item label="ระยะเวลาแพ็กเกจ (วัน)">
          {getFieldDecorator(`time`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <InputNumber
              name="name"
              placeholder="จำนวนวันที่แพ็กเกจมีผลใช้งาน"
              style={{ width: '100%' }}
              min={0}
            />
          )}
        </Form.Item>
        <Form.Item label="จำกัดการทำรายการชั่ง">
          {getFieldDecorator(`limitWeighing`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <InputNumber
              name="name"
              placeholder="กรอกตัวเลขจำนวนเต็ม"
              style={{ width: '40%' }}
              min={0}
              disabled={limitWeighingValue === 'limitWeighingZero'}
            />
          )}
          <Checkbox
            style={{ marginLeft: '10px' }}
            checked={limitWeighingValue === 'limitWeighingZero'}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldsValue({ limitWeighing: 0 })
                setLimitWeighingValue('limitWeighingZero')
              } else {
                setLimitWeighingValue(null)
              }
            }}>
            ไม่จำกัดการทำรายการชั่ง
          </Checkbox>
        </Form.Item>
        <Form.Item label="จำกัดการทำรายการบัญชี">
          {getFieldDecorator(`limitAccounting`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <InputNumber
              name="name"
              placeholder="กรอกตัวเลขจำนวนเต็ม"
              style={{ width: '40%' }}
              min={0}
              disabled={limitAccountingValue === 'limitAccountingZero'}
            />
          )}
          <Checkbox
            style={{ marginLeft: '10px' }}
            checked={limitAccountingValue === 'limitAccountingZero'}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldsValue({ limitAccounting: 0 })
                setLimitAccountingValue('limitAccountingZero')
              } else {
                setLimitAccountingValue(null)
              }
            }}>
            ไม่จำกัดการทำรายการบัญชี
          </Checkbox>
        </Form.Item>
        <Form.Item label="แสดงลายน้ำในบิลและเอกสาร">
          <Radio.Group
            value={watermarkValue}
            onChange={(e) => setWatermarkValue(e.target.value)}>
            <Radio value="show">แสดงลายน้ำ</Radio>
            <Radio value="hide">ไม่แสดงลายน้ำ</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="ระยะเวลาเก็บรูป">
          {getFieldDecorator(`saveImageLongTime`, {
            rules: [
              {
                required: true,
                message: 'กรุณากรอก'
              }
            ]
          })(
            <InputNumber
              name="name"
              placeholder="กรอกจำนวนเครื่องที่จะเพิ่มเมื่อมีการใช้งานแพ็กเกจ ถ้าไม่กรอกข้อมูลจะเท่ากับ 0"
              style={{ width: '100%' }}
              min={0}
            />
          )}
        </Form.Item>
        <Form.Item label="ส่งอีเมลรายงานยอดขายประจำวัน">
          <Radio.Group
            value={sentEmailReportValue}
            onChange={(e) => setSentEmailReportValue(e.target.value)}>
            <Radio value="show">ส่งรายงานประจำวัน</Radio>
            <Radio value="hide">ไม่ส่งรายงานประจำวัน</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="เปิดการตั้งค่าศูนย์แจ้งเตือน">
          <Radio.Group
            value={alertSettingValue}
            onChange={(e) => setAlertSettingValue(e.target.value)}>
            <Radio value="show">เปิดการตั้งค่าศูนย์การแจ้งเตือน</Radio>
            <Radio value="hide">ปิดการตั้งค่าศูนย์การแจ้งเตือน</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="Remark">
          {getFieldDecorator(`remark`)(
            <Input name="name" placeholder="หมายเหตุ" />
          )}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedPlansForm = Form.create({ name: 'PlansForm' })(PlansForm)
export default WrappedPlansForm
